<template>
  <div>
    <!-- 货盘配置 -->
    <el-dialog :title="$t('message.inventoryConfiguration')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1088px" center>
      <div class="add">
        <!-- 新增货盘 -->
        <el-button type="success" @click="addNewInventory">{{ $t('message.addNewInventory')
        }}</el-button>
      </div>
      <div class="content">
        <div class="table">
          <ol>
            <li class="flex05">ID</li>
            <!--货盘名称    -->
            <li>{{ $t('message.inventoryName') }}</li>
            <!--限制条件    -->
            <li class="flex3">{{ $t('message.restrictionCondition') }}</li>
            <!--默认使用    -->
            <li class="flex05">{{ $t('message.useByDefault') }}</li>
            <!--操作    -->
            <li class="flex05">{{ $t('message.operation') }}</li>
          </ol>
          <ul v-for="(item, index) in $parent.palletyOption" :key="index">
            <li class="flex05">{{ item.id }}</li>
            <!--货盘名称    -->
            <li><el-input v-model="item.name" @blur="setData(item)"></el-input></li>
            <!--限制条件    -->
            <li class="flex3">
              <div class="row">
                <div class="item">
                  <el-radio v-model="item.limiting_condition" :label="1" @change="setData(item)">SVIP可见</el-radio>
                  <el-radio v-model="item.limiting_condition" :label="2" @change="setData(item)"> 定额会员可见</el-radio>
                  <el-radio v-model="item.limiting_condition" :label="3" @change="setData(item)">全部客户可见</el-radio>
                </div>
              </div>
            </li>
            <!--默认使用    -->
            <li class="flex05">
              <el-checkbox v-model="item.default_checked" @change="useByDefault(item)"></el-checkbox>
            </li>
            <!--操作    -->
            <li class="flex05">
              <el-button size="mini" type="primary" class="dark" @click="palletConfigDelete(item.id)">{{
                $t('message.delete') }}</el-button>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog :title="$t('message.addNewInventory')" :close-on-click-modal="false" :visible.sync="addDialogVisible"
      width="488px" center>
      <div class="row">
        <div class="label">{{ $t('message.addNewInventory') }}:</div>
        <div class="val"><el-input v-model="itemData.name"></el-input></div>
      </div>
      <span slot="footer" class="dialog-footer">

        <!-- 保存 -->
        <el-button type="primary" @click="addItem">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      addDialogVisible: false,
      itemData: {
        id: '',
        name: '',
        limiting_condition: '',
        default_uses: '',
      },
    };
  },
  methods: {
    //新增货盘
    addItem() {
      this.$api.siteConfiguration.palletConfigSave(this.itemData).then(res => {
        this.$parent.palletConfigList()
        this.addDialogVisible = false
      })

    },
    // 货盘配置保存
    palletConfigSave() {
      this.$api.siteConfiguration.palletConfigSave(this.itemData)
    },
    addNewInventory() {
      this.itemData = {
        id: '',
        name: '',
        limiting_condition: 3,
        default_uses: 0,
      }
      this.addDialogVisible = true

    },
    //货盘配置保存
    setData(item) {
      this.itemData = {
        id: item.id,
        name: item.name,
        limiting_condition: item.limiting_condition,
        default_uses: item.default_checked ? 1 : 0,
      }
      this.palletConfigSave()
    },
    //货盘配置保存
    useByDefault(item) {
      this.$parent.palletyOption.forEach(data => {
        data.default_checked = false
        if (item.id == data.id) {
          data.default_checked = true
        }
      })
      this.itemData = {
        id: item.id,
        name: item.name,
        limiting_condition: item.limiting_condition,
        default_uses: item.default_checked ? 1 : 0,
      }
      this.palletConfigSave()
    },
    //货盘配置删除
    palletConfigDelete(id) {
      this.$confirm('确定要删除此货盘？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.siteConfiguration.palletConfigDelete({ id }).then(res => {
          this.$message.success(res.msg)
          this.$parent.palletConfigList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.add {
  margin-bottom: 24px;
  text-align: right;
}

.content {
  margin: 0px 15px;


  li {
    padding: 0 15px;
    flex: 1.5;
  }

  .flex3 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }
}

.row {
  display: flex;
  padding: 0 20px;

  .label {
    width: 100px;
    line-height: 40px;
  }

  .val {
    flex: 1;
  }
}
</style>